import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { Translate, TextFormat, getSortState, JhiPagination, JhiItemCount } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { ITransportOrder } from 'app/shared/model/transport-order.model';
import { getEntities } from './transport-order.reducer';

export const TransportOrder = () => {
  const dispatch = useAppDispatch();

  const location = useLocation();
  const navigate = useNavigate();

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getSortState(location, ITEMS_PER_PAGE, 'id'), location.search)
  );

  const transportOrderList = useAppSelector(state => state.transportOrder.entities);
  const loading = useAppSelector(state => state.transportOrder.loading);
  const totalItems = useAppSelector(state => state.transportOrder.totalItems);

  const getAllEntities = () => {
    dispatch(
      getEntities({
        page: paginationState.activePage - 1,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
      })
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (location.search !== endURL) {
      navigate(`${location.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [location.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  return (
    <div>
      <h2 id="transport-order-heading" data-cy="TransportOrderHeading">
        <Translate contentKey="integrawebApp.transportOrder.home.title">Transport Orders</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="integrawebApp.transportOrder.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/transport-order/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="integrawebApp.transportOrder.home.createLabel">Create new Transport Order</Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {transportOrderList && transportOrderList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="integrawebApp.transportOrder.id">ID</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('rideNr')}>
                  <Translate contentKey="integrawebApp.transportOrder.rideNr">Ride Nr</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('tourOrder')}>
                  <Translate contentKey="integrawebApp.transportOrder.tourOrder">Tour Order</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('orderWeight')}>
                  <Translate contentKey="integrawebApp.transportOrder.orderWeight">Order Weight</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('orderVolume')}>
                  <Translate contentKey="integrawebApp.transportOrder.orderVolume">Order Volume</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('amountStat')}>
                  <Translate contentKey="integrawebApp.transportOrder.amountStat">Amount Stat</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('serviceUnit')}>
                  <Translate contentKey="integrawebApp.transportOrder.serviceUnit">Service Unit</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('customersLoadingTime')}>
                  <Translate contentKey="integrawebApp.transportOrder.customersLoadingTime">Customers Loading Time</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('customerCollectionTime')}>
                  <Translate contentKey="integrawebApp.transportOrder.customerCollectionTime">Customer Collection Time</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('customerSetupTime')}>
                  <Translate contentKey="integrawebApp.transportOrder.customerSetupTime">Customer Setup Time</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('vehicleType')}>
                  <Translate contentKey="integrawebApp.transportOrder.vehicleType">Vehicle Type</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('vehiclePos')}>
                  <Translate contentKey="integrawebApp.transportOrder.vehiclePos">Vehicle Pos</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('carrierStatus')}>
                  <Translate contentKey="integrawebApp.transportOrder.carrierStatus">Carrier Status</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('carriageRatePlanned')}>
                  <Translate contentKey="integrawebApp.transportOrder.carriageRatePlanned">Carriage Rate Planned</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('carriageRateActual')}>
                  <Translate contentKey="integrawebApp.transportOrder.carriageRateActual">Carriage Rate Actual</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('carriageFeePlanned')}>
                  <Translate contentKey="integrawebApp.transportOrder.carriageFeePlanned">Carriage Fee Planned</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('carriageFeeActual')}>
                  <Translate contentKey="integrawebApp.transportOrder.carriageFeeActual">Carriage Fee Actual</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('customerActualTime')}>
                  <Translate contentKey="integrawebApp.transportOrder.customerActualTime">Customer Actual Time</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('amountTransportUnit')}>
                  <Translate contentKey="integrawebApp.transportOrder.amountTransportUnit">Amount Transport Unit</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('createdDate')}>
                  <Translate contentKey="integrawebApp.transportOrder.createdDate">Created Date</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('createdBy')}>
                  <Translate contentKey="integrawebApp.transportOrder.createdBy">Created By</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('lastModifiedDate')}>
                  <Translate contentKey="integrawebApp.transportOrder.lastModifiedDate">Last Modified Date</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('lastModifiedBy')}>
                  <Translate contentKey="integrawebApp.transportOrder.lastModifiedBy">Last Modified By</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('amountBarrel')}>
                  <Translate contentKey="integrawebApp.transportOrder.amountBarrel">Amount Barrel</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('amountCrate')}>
                  <Translate contentKey="integrawebApp.transportOrder.amountCrate">Amount Crate</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('amountBox')}>
                  <Translate contentKey="integrawebApp.transportOrder.amountBox">Amount Box</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('amountOthers')}>
                  <Translate contentKey="integrawebApp.transportOrder.amountOthers">Amount Others</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {transportOrderList.map((transportOrder, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/transport-order/${transportOrder.id}`} color="link" size="sm">
                      {transportOrder.id}
                    </Button>
                  </td>
                  <td>{transportOrder.rideNr}</td>
                  <td>{transportOrder.tourOrder}</td>
                  <td>{transportOrder.orderWeight}</td>
                  <td>{transportOrder.orderVolume}</td>
                  <td>{transportOrder.amountStat}</td>
                  <td>{transportOrder.serviceUnit}</td>
                  <td>{transportOrder.customersLoadingTime}</td>
                  <td>{transportOrder.customerCollectionTime}</td>
                  <td>{transportOrder.customerSetupTime}</td>
                  <td>{transportOrder.vehicleType}</td>
                  <td>{transportOrder.vehiclePos}</td>
                  <td>{transportOrder.carrierStatus}</td>
                  <td>{transportOrder.carriageRatePlanned}</td>
                  <td>{transportOrder.carriageRateActual}</td>
                  <td>{transportOrder.carriageFeePlanned}</td>
                  <td>{transportOrder.carriageFeeActual}</td>
                  <td>{transportOrder.customerActualTime}</td>
                  <td>{transportOrder.amountTransportUnit}</td>
                  <td>
                    {transportOrder.createdDate ? (
                      <TextFormat type="date" value={transportOrder.createdDate} format={APP_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>{transportOrder.createdBy}</td>
                  <td>
                    {transportOrder.lastModifiedDate ? (
                      <TextFormat type="date" value={transportOrder.lastModifiedDate} format={APP_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>{transportOrder.lastModifiedBy}</td>
                  <td>{transportOrder.amountBarrel}</td>
                  <td>{transportOrder.amountCrate}</td>
                  <td>{transportOrder.amountBox}</td>
                  <td>{transportOrder.amountOthers}</td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`/transport-order/${transportOrder.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/transport-order/${transportOrder.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/transport-order/${transportOrder.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="integrawebApp.transportOrder.home.notFound">No Transport Orders found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={transportOrderList && transportOrderList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default TransportOrder;
